import React from "react";

export const AutoGraph = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none"
      {...props}
    >
      <path
        d="M35.8102 25.4008L30.6602 23.0508L35.8102 20.7008L38.1602 15.5508L40.5102 20.7008L45.6602 23.0508L40.5102 25.4008L38.1602 30.5508L35.8102 25.4008ZM10.6602 35.5508L13.0102 30.4008L18.1602 28.0508L13.0102 25.7008L10.6602 20.5508L8.31016 25.7008L3.16016 28.0508L8.31016 30.4008L10.6602 35.5508ZM21.9102 23.0508L24.6352 17.0258L30.6602 14.3008L24.6352 11.5758L21.9102 5.55078L19.1852 11.5758L13.1602 14.3008L19.1852 17.0258L21.9102 23.0508ZM11.9102 51.8008L26.9102 36.7758L36.9102 46.7758L58.1602 22.8758L54.6352 19.3508L36.9102 39.2758L26.9102 29.2758L8.16016 48.0508L11.9102 51.8008Z"
        fill="#4F9CF9"
      />
    </svg>
  );
};
